import { useTranslation } from 'react-i18next'
import { ConfigurationHeaderWrapper } from '../../../../../_components/configuration-header-wrapper.component'
import { getTranslatedLabel } from 'src/utils/locale.util'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { NodeEditor } from '../_components/chatbot-flow/node-editor.component'
import { NodeForm } from '../_components/chatbot-form/node-form.component'
import { ChatbotFlowProvider } from '../_components/chatbot.provider'
import { useSelfConfigurationFollowup } from '../../../_components/use-self-configuration-followup.hook'
import { useParams } from 'react-router-dom'
import { useLocale } from 'src/hooks/use-locale'

export default function ChatbotUpdateNodePage() {
  const { t } = useTranslation()
  const { project } = useCurrentProject()
  const { followupId, chatbotId } = useParams()
  const { locale } = useLocale()

  const { data: followupTimeline } = useSelfConfigurationFollowup(followupId as string)

  return (
    <ConfigurationHeaderWrapper
      title={t('pages.configuration.followups.manage-followup', {
        followupName: getTranslatedLabel(locale, followupTimeline?.intlName),
      })}
    >
      <ChatbotFlowProvider
        projectId={project.id}
        followupId={Number(followupId)}
        chatbotId={Number(chatbotId)}
      >
        <div className="c-flex c-h-full">
          <NodeEditor />
          <NodeForm />
        </div>
      </ChatbotFlowProvider>
    </ConfigurationHeaderWrapper>
  )
}
